module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-07.af32951b.png";